import React from 'react';
import { type RouteObject } from 'react-router-dom';

import PageChangePassword from './index';

/**
 * Route for the authenticated change-password flow (SPB-480).
 *
 * Like `/login`, `/register` and `/reset-password`, this is a full-bleed experience that owns the
 * whole viewport and brings its own backdrop, so it is mounted as a standalone route (NOT through
 * the account-chrome layouts). Unlike those siblings it IS auth-gated, but the gate lives IN the
 * page (`useAuthGate`): a signed-out owner who reaches it is sent to `/login`. `src/routes.tsx`
 * prepends this before the config-driven routes so it wins the specificity tie against any remote
 * config page at this path.
 *
 * SINGLE mount at `/change-password` (hyphen). The BE change-password notification emails the
 * hyphen path `{ownerHubFrontUrl}/change-password?code=<code>`, so there is NO underscore alias
 * (unlike reset-password's dual `/reset-password` + `/reset_password` mount). The page reads
 * `?code=` and prefills the enter-code view from it.
 */
export const changePasswordRoute: RouteObject = {
  path: '/change-password',
  element: <PageChangePassword />,
};

export default changePasswordRoute;
